globalThis.CLIENT_SIDE = true;

function startMainApp() {
  const app = require("./main_app");
}
function startTabsToolbar() {
  const app = require("./main_tabstoolbar");
}

function startBootProcess() {
  const app = require("./main_boot");
}
function startServerWaiting() {
  const app = require("./main_net");
}

//override console.error and log for electron
function initLoggers() {
  try {
    if (!globalThis.ELECTRON_ENV) return;
    var _error = console.error;
    var _log = console.log;
    console.error = function (errMessage) {
      if (globalThis.ELECTRON_ENV)
        globalThis.LOG_EXCEPTION(errMessage, "client-side");
      _error.apply(console, arguments);
    };

    console.log = function (errMessage) {
      if (globalThis.ELECTRON_ENV)
        globalThis.LOG_ERROR(errMessage, "client-side");
      _log.apply(console, arguments);
    };
  } catch (ex) {
    console.log("error in init loggers");
    console.error(ex);
  }
}
// initLoggers();

if (window.location.href.endsWith("startBootProcess")) startBootProcess();
else if (window.location.href.endsWith("startNetworkServerProcess"))
  startServerWaiting();
else if (window.location.href.endsWith("tabs_toolbar")) startTabsToolbar();
else {
  if (globalThis.ELECTRON_ENV) {
    if (globalThis.ELECTRON_READY_UI) startMainApp();
    else window.addEventListener("ready_ui", startMainApp, { capture: true });
  } else startMainApp();
}
